import { createBrowserHistory } from 'history';
import { RouterStore, syncHistoryWithStore } from '@superwf/mobx-react-router';
const browserHistory = createBrowserHistory();
const routingStore = new RouterStore();

const unlisten = browserHistory.listen((location, action) => {
  // location is an object like window.location
  if(typeof window.historyListener == 'function') {
    window.historyListener(location,action);
  }
});


export const stores={
  // Key can be whatever you want
  router: routingStore,
  // ...other stores
};

export const history = syncHistoryWithStore(browserHistory, routingStore);

// export const history;



